import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'

import Button from 'components/common/Button'
import LoginConfirmationMessage from 'src/components/LoginConfirmationMessage'
import SvgIcon from 'components/common/SvgIcon'

import styles from './login-confirmation-form.scss'
import inputStyles from 'src/styles/inputs.css'
import LeftChevronIcon from '../assets/icons/left_chevron.svg'

export default class LoginConfirmationForm extends React.Component {
  _setConfirmationCode = (event) => {
    const { updateForm, onSubmitConfirmation } = this.props
    const value = event.target.value

    updateForm({
      confirmationCode: value,
      confirmationCodeValid: 'unknown'
    })
    if (value.length === 6) {
      onSubmitConfirmation(value)
      localStorage.removeItem('polls')
    }
  };

  _onSubmit = (event) => {
    const { onSubmitConfirmation } = this.props
    const { confirmationCode } = this.props.loginForm

    event.preventDefault()
    onSubmitConfirmation(confirmationCode)
  };

  _validateConfirmationCode () {
    const { confirmationCode } = this.props.loginForm

    return !(confirmationCode.length === 6)
  }

  render () {
    const {
      loginForm,
      onResendCode,
      transparent,
      contactMethod,
      backToContactMethodFieldsFormPage
    } = this.props
    const { confirmationCode, confirmationCodeValid } = loginForm

    const inputValidClass = confirmationCodeValid ? null : (transparent ? styles['error-transparent'] : styles.error)
    const inputClass = transparent ? 'transparent-text-input' : 'text-input'

    return (
      <div>
        <div className={styles['icon-wrapper']}>
          <SvgIcon className={styles['left-chevron-icon']} icon={LeftChevronIcon} padding='5px' onClick={backToContactMethodFieldsFormPage} />
        </div>
        <LoginConfirmationMessage contactMethod={contactMethod} loginForm={loginForm} />
        <form className={styles['form']} onSubmit={this._onSubmit}>
          <div className={styles['name-fields']}>
            <input
              autoFocus
              type='tel'
              autoComplete='off'
              className={classnames(inputValidClass, inputStyles[inputClass], styles['code-input'])}
              placeholder='Enter your six digit code'
              value={confirmationCode}
              onChange={this._setConfirmationCode}
            />
            <a className={styles['action-link']} onClick={onResendCode}>Resend Code</a>
          </div>
          <div className={styles['button-wrapper']}>
            <Button disabled={this._validateConfirmationCode()} className={styles['button']} onClick={this._onSubmit}>
              done
            </Button>
          </div>
          <input style={{ display: 'none' }} type='submit' />
        </form>
      </div>
    )
  }
}

LoginConfirmationForm.propTypes = {
  contactMethod: PropTypes.object,
  loginForm: PropTypes.object.isRequired,
  onSubmitConfirmation: PropTypes.func.isRequired,
  onResendCode: PropTypes.func.isRequired,
  updateForm: PropTypes.func.isRequired,
  transparent: PropTypes.bool,
  backToContactMethodFieldsFormPage: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/LoginConfirmationForm.jsx